// extracted by mini-css-extract-plugin
export default {"root":"u98AHE","content":"PppWBH","sellerGroup":"ERXbHe","emptyState":"OfmhhZ","emptyStateTitle":"xHJQJ6","emptyStateDescription":"V7O16l","toPurchasesButton":"IE71Bv"};